const START_CHUNK_SIZE = 8 * 1024 * 1024;
const START_MULTIPART_SIZE = START_CHUNK_SIZE * 2;
const MAX_CHUNK_SIZE = 5 * 1024 * 1024 * 1024;
const MAX_PARTS = 900;
const CHUNK_MULT = 64;
const SIZE_BREAK1 = START_CHUNK_SIZE * MAX_PARTS;
const SIZE_BREAK2 = START_CHUNK_SIZE * CHUNK_MULT * MAX_PARTS;

exports.calcChunkSize = calcChunkSize;
exports.START_MULTIPART_SIZE = START_MULTIPART_SIZE;

function calcChunkSize(size) {
  let chunk_size;
  if (size <= START_MULTIPART_SIZE) {
    chunk_size = START_MULTIPART_SIZE;
  } else if (size <= SIZE_BREAK1) {
    chunk_size = START_CHUNK_SIZE;
  } else if (size <= SIZE_BREAK2) {
    chunk_size = START_CHUNK_SIZE * CHUNK_MULT;
  } else {
    chunk_size = MAX_CHUNK_SIZE;
  }
  return chunk_size;
}

/*
const MAX_PARTS = 900;
const CHUNK_MULT = 8;

const SIZE1 = 8 * 1024 * 1024;
const SIZE2 = SIZE1 * CHUNK_MULT;
const SIZE3 = SIZE2 * CHUNK_MULT;
const MAX_CHUNK_SIZE = 5 * 1024 * 1024 * 1024;

const SIZE_BREAK1 = START_CHUNK_SIZE * MAX_PARTS;
const SIZE_BREAK2 = SIZE_BREAK1 * CHUNK_MULT;
const SIZE_BREAK3 = SIZE_BREAK2 * CHUNK_MULT;

const START_MULTIPART_SIZE = SIZE1 * 2;

exports.calcChunkSize = calcChunkSize;
exports.START_MULTIPART_SIZE = START_MULTIPART_SIZE;

function calcChunkSize(size) {
  let chunk_size;
  if (size <= START_MULTIPART_SIZE) {
    chunk_size = START_MULTIPART_SIZE;
  } else if (size <= SIZE_BREAK1) {
    chunk_size = SIZE1;
  } else if (size <= SIZE_BREAK2) {
    chunk_size = SIZE2
  } else if (size <= SIZE_BREAK3) {
    chunk_size = SIZE3
  } else {
    chunk_size = MAX_CHUNK_SIZE;
  }
  return chunk_size;
}
*/
